import AxiosConfig from '@/config/axios-config'

export const DisciplinaAPI = {

  listarHome () {
    return AxiosConfig.secureJalekoAPI().get('/disciplinas').then(response => response.data)
  },

  obterPorReferencia (referencia) {
    return AxiosConfig.secureJalekoAPI().get(`/disciplinas/${referencia}`).then(response => response.data)
  },

  obterEstatisticas (referencia) {
    return AxiosConfig.secureJalekoAPI().get(`/resumodisciplina/${referencia}`).then(response => response.data)
  }

}

export default DisciplinaAPI
